import { render } from "./vuestic-logo.vue?vue&type=template&id=67a07e97"
import script from "./vuestic-logo.vue?vue&type=script&lang=js"
export * from "./vuestic-logo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__